import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import { DatePicker, Drawer, message, Popconfirm, Select } from "antd";
import { map } from "lodash";
import moment from "moment-timezone";
import React, { Component } from "react";
import * as yup from "yup";
import Loader from "../../../../Common/Component/Loader";
import {errorHandle} from "../../../../Common/errorHandle";

const { Option } = Select;

class PauseService extends Component {
  state = {
    pauseList: [],
    pauseReason: {},
    from: "",
    to: "",
    reason: "",
    suspend_until_manual: false,
    is_btn_active: false,
    loader: false,
    errors: {},
  };

  componentDidMount = () => {
    this.setState({ loader: true });
    // this.props.getPauseReason(); // get pause reason
    // this.props.getPauseService({ service_order__uuid: this.props.serviceId }) // get pause service list
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    this.setState({ loader: false });
    // message.destroy();
    if (nextProps?.Service?.errors && nextProps?.Service?.errors?.length > 0
      && JSON.stringify(nextProps?.Service?.errors) !== JSON.stringify(this.state.errors)) {
      this.setState({ errors: nextProps?.Service?.errors });
      errorHandle(nextProps?.Service?.errors)
      // message.error(nextProps?.Service?.errors?.[0], 10);
    }

    // get service
    if (Object.keys(nextProps?.Service?.pauseList).length > 0
      && JSON.stringify(nextProps?.Service?.pauseList) !== JSON.stringify(this.state.pauseList)) {
      this.setState({ pauseList: nextProps?.Service?.pauseList });
    }

    if (Object.keys(nextProps?.Service?.pauseReason).length > 0) {
      this.setState({ pauseReason: nextProps?.Service?.pauseReason });
    }
  };

  // on Text change
  onTextChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // validate required fields
  validate = () => {
    const { from, to, reason, suspend_until_manual } = this.state;

    const schema = yup.object().shape({
      suspend_until_manual: yup.bool(),
      from: yup.string().required("From Date is required"),
      to: yup.string().when("suspend_until_manual", {
        is: (suspend_until_manual) => !suspend_until_manual,
        then: yup.string().required("To Date is required"),
      }),
      reason: yup.string().required("Reason is required"),
    });

    const data = { suspend_until_manual, from, to, reason };

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({ is_btn_active: true, errors: {} });
        this.onPause();
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => {
          err_data[item.path] = item.message;
        });
        this.setState({ errors: err_data, is_btn_active: false });
      });
    }, 200);
  };

  // on pause
  onPause = () => {
    const { serviceId, getPauseService, viewService } = this.props;
    const { from, to, reason, suspend_until_manual } = this.state;
    this.setState({ loader: true });
    this.props.pauseService({
      service_order_uuid: serviceId,
      understand_pause_func: false,
      pause_from: moment(from).format("YYYY-MM-DD"),
      pause_to: to ? moment(to).format("YYYY-MM-DD") : null,
      service_reason_uuid: reason,
      suspend_until_manual,
    });
    setTimeout(() => {
      getPauseService({ service_order__uuid: serviceId });
      viewService({ service_order__uuid: serviceId, limit: 10, offset: 0 });
    }, 1000);
    // closeDrawer && closeDrawer();
    this.onClear();
  };

  // on cancel
  onCancel = () => {
    const { closeDrawer } = this.props;
    closeDrawer && closeDrawer();
    this.onClear();
  };

  // on clear
  onClear = () => {
    this.setState({ from: "", to: "", reason: "", suspend_until_manual: false, errors: {} });
  };

  // on remove pause service click
  onRemovePauseService = (uuid) => {
    const { pauseList } = this.state;
    this.props.deletePauseService(uuid);
    const idx = pauseList?.results?.findIndex(obj => obj?.uuid === uuid);
    if (idx > -1 && pauseList.results) {
      pauseList.results.splice(idx, 1);
      this.setState({ pauseList });
    }
    setTimeout(() => this.props.viewService({ service_order__uuid: this.props.serviceId, limit: 10, offset: 0 }), 1000);
  };

  render() {
    const { closeDrawer, visible } = this.props;
    const { pauseList, from, to, reason, suspend_until_manual, loader, pauseReason, errors } = this.state;
    return (
      <Drawer
        placement={"right"}
        closable={false}
        onClose={closeDrawer}
        visible={visible}
        key={"right"}
        width={"400"}
        className="drawer-wrapper"
      >
        <div className="filter_drawer_wrapper  rdrawer">
          {loader && <Loader/>}
          <div className="card-head flex ai-center">
            <h4>Pause Service</h4>
            <CloseOutlined onClick={closeDrawer}/>
          </div>
          <div className="card-row flex-column">
            <div className="card-full">
              <div className="form-group">
                <div className="fitem half-fitem">
                  <div className="fitem half-fitem">
                    <label htmlFor="from">From</label>
                    <DatePicker
                      id={"from"}
                      name='from'
                      inputReadOnly
                      disabledDate={(current) => {
                        return current && current <= moment().endOf("day");
                      }}
                      placeholder={"mm-dd-yyyy"}
                      format={"MM-DD-YYYY"}
                      value={from ? moment(from, "MM-DD-YYYY") : null}
                      onChange={(e) => this.onTextChange({ target: { name: "from", value: e } })}
                      className="reverse"/>
                    {errors?.["from"] ?
                      <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.["from"]}</label> : ""}
                  </div>
                  <div className="fitem half-fitem">
                    <label htmlFor="to">To</label>
                    <DatePicker
                      id={"to"}
                      name='to'
                      inputReadOnly
                      disabled={suspend_until_manual}
                      disabledDate={(endValue) => {
                        return endValue.valueOf() <= moment(moment(from, "DD/MM/YYYY")).valueOf();
                      }}
                      placeholder={"mm-dd-yyyy"}
                      format={"MM-DD-YYYY"}
                      value={to ? moment(to, "MM-DD-YYYY") : null}
                      onChange={(e) => this.onTextChange({ target: { name: "to", value: e } })}
                      className="reverse"/>
                    {errors?.["to"] ?
                      <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.["to"]}</label> : ""}
                  </div>
                </div>

              </div>
              <button
                className="success btn plain-btn"
                onClick={() => this.setState({ suspend_until_manual: !suspend_until_manual, to: "" })}>
                {/*{suspend_until_manual && <CheckOutlined style={{ marginRight: 8 }}/>}*/}
                <b>Pause Until Manual</b>
              </button>
              <div className="fitem half-fitem mt-10">
                <label>Reason</label>
                <div>
                  <Select
                    showArrow
                    showSearch
                    placeholder={"Choose a reason for pausing this service"}
                    virtual={false}
                    style={{ width: "100%" }}
                    value={reason || undefined}
                    onChange={(e) => this.onTextChange({ target: { name: "reason", value: e } })}
                  >
                    {map(pauseReason?.results, (x) => <Option value={x.uuid} key={x.uuid}>{x.reason}</Option>)}
                  </Select>
                  {errors?.["reason"] ?
                    <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.["reason"]}</label> : ""}
                </div>
              </div>
            </div>
            <div className="">
              <div className="d-block mt-30">
                <h4 className="ml-30 mr-30">Existing Pauses</h4>
                {
                  map(pauseList?.results, (item, index) => {
                    const reason = pauseReason?.results?.find(x => x.uuid === item?.service_reason_uuid);
                    return (
                      <div className="pause-serv" key={`pauseService${index}`}>
                        <div className="flex">
                          <span
                            className="flex-1">{item?.suspend_until_manual ? moment(item.pause_from).format("ddd, MMM DD") : `${moment(item.pause_from).format("ddd, MMM DD")} to ${moment(item.pause_to).format("ddd, MMM DD")}`}&nbsp;&nbsp;
                            <u
                              className={item?.suspend_until_manual ? "cursor_pointer" : ""}
                              onClick={() => this.onRemovePauseService(item?.uuid)}>
                              <b>{item?.suspend_until_manual ? "Resume Service Now" : ""}</b>
                            </u>
                          </span>
                          <Popconfirm
                            title="Are you sure?"
                            onConfirm={() => this.onRemovePauseService(item?.uuid)}
                            okText="Yes"
                            cancelText="No"
                            overlayClassName={"popup-width"}
                          >
                            <DeleteOutlined/>
                          </Popconfirm>
                        </div>
                        <p className="mb-0">{reason?.reason}</p>
                      </div>
                    );
                  })
                }
              </div>
            </div>

          </div>
          <div className="footer">
            <button className={`btn btn-bdr`} onClick={() => this.onCancel()}>Cancel</button>
            <button
              // type="submit"
              className={`btn btn-warning`}
              // disabled={!is_btn_active}
              onClick={() => this.validate()}>
              Pause Service
            </button>
          </div>
        </div>
      </Drawer>
    );
  }
}

export default PauseService;
